import { Document } from '@contentful/rich-text-types';
import cn from 'classnames';
import ImpressionTrackerNew from 'components/impression-tracker/new-impression-tracker';
import { SegmentationIds } from 'constants/segmentation';
import { useSegmentationContext } from 'contexts/segmentation';
import useIsClient from 'hooks/common/use-is-client';
import useMobile from 'hooks/common/use-mobile';
import { ProductSegmentation } from 'modules/product-details/types';
import { useMemo } from 'react';
import styles from '../../pdp.module.css';
import UspsView from './usps-view';
import { resolveSegmentUsps } from './utils';

interface PropTypes {
  defaultContent: Document;
  segmentation?: ProductSegmentation['segmentation'] | null;
  uspTitle?: React.ReactNode;
}

const Usps: React.FC<PropTypes> = ({
  defaultContent,
  segmentation,
  uspTitle,
}) => {
  const { isClient } = useIsClient();
  const isMobile = useMobile();
  const { segmentation: segmentId, shouldOmitPersonalization } =
    useSegmentationContext();

  const dataTestValue = isMobile ? 'pdp-bullets-mob' : 'product-bullets';

  const content = useMemo(() => {
    if (!segmentation || !segmentId || shouldOmitPersonalization)
      return defaultContent;

    const segmentUsps = resolveSegmentUsps(
      segmentation,
      segmentId as SegmentationIds
    );

    return segmentUsps ?? defaultContent;
  }, [defaultContent, segmentation, segmentId, shouldOmitPersonalization]);

  if (!isClient) return null;

  return (
    <ImpressionTrackerNew element={'PDP USPs'}>
      <UspsView
        content={content}
        classNames={cn(styles.customList, 'mt-5 text-sm lg:mb-0')}
        dataTest={dataTestValue}
        uspTitle={uspTitle}
      />
    </ImpressionTrackerNew>
  );
};

export default Usps;
